import { TextStatus } from '@cko/primitives';
import styled from 'styled-components';

type WrapperProps = {
  isBlocked?: boolean;
};
export const Wrapper = styled.div<WrapperProps>`
  align-items: center;
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
  display: flex;
  gap: var(--layout-shoe);
  justify-content: start;
  padding: var(--layout-sandgrain) var(--layout-sandgrain) var(--layout-stamp)
    var(--layout-sandgrain);
`;

export const StyledTextStatus = styled(TextStatus)`
  margin-left: var(--layout-seed);
`;
